import _ from "underscore";

import closestPlanHelper from "./ClosestPlan";

const planTierHigher = {
  bronze: "silver",
  silver: "gold",
  gold: "platinum",
};

export default function selectSimilarPlans(plan, allPlans) {
  if (!plan) return [];
  const fourPlans = [[plan, "This Plan"]];
  let filteredPlans = _.without(allPlans, plan);

  // Filter for lower deductible, similar plan
  if (_.filter(filteredPlans, (planCompare) => planCompare.deductible < plan.deductible).length > 0) {
    const lowerDeductiblePlans = _.filter(filteredPlans, (planCompare) => planCompare.deductible < plan.deductible);

    const closestPlan = closestPlanHelper(lowerDeductiblePlans, plan, true);
    filteredPlans = _.without(filteredPlans, closestPlan);
    fourPlans.push([closestPlan, "Lower Deductible"]);
  } else if (_.filter(filteredPlans, (planCompare) => planCompare.deductible > plan.deductible).length > 0) {
    const higherDeductiblePlans = _.filter(filteredPlans, (planCompare) => planCompare.deductible > plan.deductible);

    const closestPlan = closestPlanHelper(higherDeductiblePlans, plan, true);
    filteredPlans = _.without(filteredPlans, closestPlan);
    fourPlans.push([closestPlan, "Higher Deductible"]);
  }

  // Filter for lower doctor copays
  if (
    plan.estimated_costs.pcp_visit == 90 &&
    _.filter(filteredPlans, (planCompare) => planCompare.estimated_costs.pcp_visit < plan.estimated_costs.pcp_visit).length > 0
  ) {
    const lowerDoctorVisitPlans = _.filter(filteredPlans, (planCompare) => planCompare.estimated_costs.pcp_visit < plan.estimated_costs.pcp_visit);

    const closestPlan = closestPlanHelper(lowerDoctorVisitPlans, plan, true);
    filteredPlans = _.without(filteredPlans, closestPlan);
    fourPlans.push([closestPlan, "Has Doctor Copays"]);
  }

  // Filter for different Carrier, same Type
  if (_.filter(filteredPlans, (planCompare) => planCompare.carrier != plan.carrier && planCompare.plan_type == plan.plan_type).length > 0) {
    const differentCarrierPlans = _.filter(filteredPlans, (planCompare) => planCompare.carrier != plan.carrier && planCompare.plan_type == plan.plan_type);

    const closestPlan = closestPlanHelper(differentCarrierPlans, plan, false);
    filteredPlans = _.without(filteredPlans, closestPlan);
    fourPlans.push([closestPlan, "Different Carrier"]);
  } else if (_.filter(filteredPlans, (planCompare) => planCompare.carrier != plan.carrier).length > 0) {
    const differentCarrierPlans = _.filter(filteredPlans, (planCompare) => planCompare.carrier != plan.carrier);

    const closestPlan = closestPlanHelper(differentCarrierPlans, plan, false);
    filteredPlans = _.without(filteredPlans, closestPlan);
    fourPlans.push([closestPlan, "Different Carrier"]);
  }

  // Filter for higher coverage, similar plan
  if (plan.metal_tier != "platinum") {
    const nextTier = planTierHigher[plan.metal_tier];
    const higherCoveragePlans = _.filter(filteredPlans, (planCompare) => planCompare.metal_tier == nextTier);

    if (higherCoveragePlans.length > 0) {
      const closestPlan = closestPlanHelper(higherCoveragePlans, plan, true);
      filteredPlans = _.without(filteredPlans, closestPlan);
      fourPlans.push([closestPlan, "Higher Metal Tier"]);
    }
  } else {
    const nextTier = "gold";
    const lowerCoveragePlans = _.filter(filteredPlans, (planCompare) => planCompare.metal_tier == nextTier);

    if (lowerCoveragePlans.length > 0) {
      const closestPlan = closestPlanHelper(lowerCoveragePlans, plan, true);
      filteredPlans = _.without(filteredPlans, closestPlan);
      fourPlans.push([closestPlan, "Lower Metal Tier"]);
    }
  }

  return fourPlans;
}
